// extracted by mini-css-extract-plugin
module.exports = {"link":"BlockLink_link__3CAXF"};